<div class="app-shell"
     [class.has-cart]="!isLoginRoute() && !isPortalRoute() && !isAffiliateRoute()"
     [class.search-expanded]="expanded()">
  <mat-toolbar class="app-toolbar">
    <mat-toolbar-row class="toolbar-row">
      <button mat-icon-button class="topnav-icon menu-button" aria-label="icon-button with menu icon" i18n-aria-label="@@nav.menu.ariaLabel"
        (click)="toggle()">
        <mat-icon>{{ sidenav.opened ? "close" : "menu" }}</mat-icon>
      </button>
      <div class="logo-container" (click)="closeSidenav()">
        <div class="logo-wrapper">
          <a routerLink="/" (click)="shut()">
            <!-- Light theme logo (current) -->
            <img class="logo-light" alt="Aposmart logo" i18n-alt="@@nav.logo.alt" ngSrc="assets/logo_aposmart_lower.svg" fill />

            <!-- Dark theme logo (new) -->
            <img class="logo-dark" alt="Aposmart logo" i18n-alt="@@nav.logo.alt" ngSrc="assets/logo_aposmart_lower_n.svg" fill />
          </a>
        </div>
      </div>
      @defer {
      @if (!isLandingPage()) {
      <app-product-search class="desktop-search" (closeSearchEvent)="expanded.set(false)" />}
      <div class="mobile-search-actions">
        @if (scanEnabled && currentUrl() !== '/scan' && !expanded()) {
        <button class="topnav-icon barcode-button" mat-icon-button (click)="router.navigate(['/scan'])">
          <span class="material-symbols-outlined icon-muted">barcode_scanner</span>
        </button>
        <div class="icon-divider"></div>
        }
        <button class="topnav-icon search-button" matSuffix mat-icon-button (click)="openSearchDialog()">
          <mat-icon class="icon-muted">
            {{ expanded() ? "close" : "search" }}
          </mat-icon>
        </button>
      </div>} @error {}
    </mat-toolbar-row>
  </mat-toolbar>

  @if (!isPortalRoute() && !isLoginRoute() && !isAffiliateRoute()) {
  <aside class="cart-rail" [class.collapsed]="cartCollapsed()" [class.cart-ready]="cartReady()" (click)="goToCart()">
    @defer {
    <button [matBadge]="totalProducts()" matBadgeSize="large" routerLink="/cart" mat-icon-button class="cart-button"
      id="cartButton">
      <mat-icon>list_alt</mat-icon>
    </button>
    <div class="cart-label">
      <span i18n="@@nav.cart.label">Inköpslista</span>
      @if (includeShipping()) {
      <span class="cart-shipping-hint" i18n="@@cart.priceInclShipping">Pris inkl. frakt</span>
      }
    </div>
    } @error {}
    @if (!cartCollapsed()) {
    @for (row of railRows(); track $index) {
    <div class="apotek-container">
      @if (row.kind === 'option') {
      <div class="price-container">
        <div class="price-row">
          @defer {
          <span class="product-price">{{ stylePrice2(row.plan.total)
            }}<span class="price-currency">{{ currencySymbol() }}</span></span>} @error {}
        </div>
        <!-- AC-22: the option card's header grammar at rail width, one mark per
             store joined by a plus. A single-store option keeps the 85 x 22
             container it had; the marks of a multi-store option share the row. -->
        <div class="rail-marks" [attr.data-shared]="row.plan.groups.length > 1 ? '' : null">
          @for (group of row.plan.groups; track group.vendorId; let position = $index) {
          @if (position > 0) {
          <span class="rail-plus" aria-hidden="true">+</span>
          }
          @if (getImage(group.vendorId); as logo) {
          <div class="apotek-image-container">
            <img [ngSrc]="logo" [alt]="getDisplayName(group.vendorId)" fill class="apotek-logo" />
          </div>
          } @else {
          <span class="apotek-name">{{ getDisplayName(group.vendorId) }}</span>
          }
          }
        </div>
      </div>
      } @else {
      <div class="price-container">
        <div class="price-row">
          @defer {
          <span class="product-sale">⚠️ </span>
          <span class="product-price">{{ stylePrice2(warningPrice(row.offer))
            }}<span class="price-currency">{{ currencySymbol() }}</span></span>} @error {}
        </div>
        @if (getImage(row.offer.name)!) {
        <div class="apotek-image-container">
          <img [ngSrc]="getImage(row.offer.name)!" [alt]="getDisplayName(row.offer.name) + ' logo'" fill class="apotek-logo" />
        </div>
        } @else {
        <span class="apotek-name">{{ getDisplayName(row.offer.name) }}</span>
        }
      </div>
      }
      @defer { @if ($first && row.kind === 'option') {
      <span class="label-cheapest" i18n="@@nav.cart.cheapest">LÄGSTA PRIS</span>
      } } @error {}
    </div>
    }
    <div class="more-link" (click)="goToCart()">
      +
    </div>
    }
    <button mat-icon-button class="cart-collapse-btn" (click)="toggleCart(); $event.stopPropagation()">
      <mat-icon>{{ cartCollapsed() ? 'expand_more' : 'expand_less' }}</mat-icon>
    </button>
  </aside>
  }

  <mat-sidenav-container class="main-content" (backdropClick)="closeSidenav()">
    <mat-sidenav class="main-sidenav" #sidenav (keydown.escape)="closeSidenav()" disableClose
      [mode]="sidenavMode()" [fixedInViewport]="sidenavFixed()" [fixedTopGap]="sidenavTopGap()">
      @defer {
      <div class="sidenav-padding">
        <div class="links-container stack" style="--stack-gap: 0">
          <a [routerLink]="campaignsPath" mat-button class="category-button"
            (click)="closeSidenav()" i18n="@@nav.campaigns">
            <mat-icon>campaign</mat-icon>
            Kampanjer
          </a>
		  <!--<a [routerLink]="['/chat']" mat-button class="category-button" (click)="closeSidenav()">
            <mat-icon>smart_toy</mat-icon>
            AposmartAI
          </a>-->
          @if (guidesEnabled) {
          <a [routerLink]="['/guide']" mat-button class="category-button" (click)="closeSidenav()" i18n="@@nav.price.guides">
            <mat-icon>trending_up</mat-icon>
            Prisguider
          </a>
          }
          @if (toplistsEnabled) {
          <a routerLink="/toplist" mat-button class="category-button" (click)="closeSidenav()" i18n="@@nav.toplists">
            <mat-icon>leaderboard</mat-icon>
            Bästsäljare
          </a>
          }
        </div>
        <app-product-categories (closeEvent)="closeSidenav()" [load]="true" [reducedCategories]="[]" />
      </div>
      } @error {}
    </mat-sidenav>
    <mat-sidenav-content class="sidenav-content-wrapper"
      (click)="closeSidenav()">
      <div class="site-layout center" [class.has-sidebar]="!isLoginRoute() && !isPortalRoute() && !isAffiliateRoute() && !isCartRoute()" style="--center-max: var(--layout-max)">
      @if (!isLoginRoute() && !isPortalRoute() && !isAffiliateRoute() && !isCartRoute()) {
      <aside class="sidebar-nav">
        @defer {
        <div class="sidenav-padding">
          <div class="links-container stack" style="--stack-gap: 0">
            <a [routerLink]="campaignsPath" mat-button class="category-button" i18n="@@nav.campaigns">
              <mat-icon>campaign</mat-icon>
              Kampanjer
            </a>
            <!--<a [routerLink]="['/chat']" mat-button class="category-button">
              <mat-icon>smart_toy</mat-icon>
              AposmartAI
            </a>-->
            @if (guidesEnabled) {
            <a [routerLink]="['/guide']" mat-button class="category-button" i18n="@@nav.price.guides">
              <mat-icon>trending_up</mat-icon>
              Prisguider
            </a>
            }
            @if (toplistsEnabled) {
            <a routerLink="/toplist" mat-button class="category-button" i18n="@@nav.toplists">
              <mat-icon>leaderboard</mat-icon>
              Bästsäljare
            </a>
            }
          </div>
          <app-product-categories [load]="true" [reducedCategories]="[]" />
        </div>
        } @error {}
      </aside>
      }
      <div class="center stack" style="--stack-gap: 0">

        <div id="top"></div>
        <div class="sidenav-content">
          <router-outlet (activate)="onActivate()" />
		  @defer { @if (!isChatRoute() && totalProducts() > 0) {
          <button mat-fab [matBadge]="totalProducts()" (click)="navigateToCart()" matBadgeSize="large"
            aria-label="list_alt" class="cart-fab" id="cartButton">
            @if (!isCartRoute()) {
            <mat-icon>list_alt</mat-icon>
            } @else {
            <mat-icon>arrow_backward</mat-icon>
            }</button>} } @error {}
        </div>
      </div>
      </div>
      <!-- The /go continue page is noindex and exists only to send the visitor on, so
           the footer links carry no SEO value there. The toolbar stays: without it the
           page looks broken. -->
      @if (!isAffiliateRoute()) {
		<footer class="footer">
		  <div class="center stack" style="--center-max: var(--layout-max); --stack-gap: var(--space-l)">
          <a routerLink="/" (click)="shut()" class="footer-logo">
            <img alt="Aposmart logo" i18n-alt="@@nav.logo.alt" routerLink="/" routerLinkActive="active" ariaCurrentWhenActive="page"
              ngSrc="assets/logo_aposmart_lower_n.svg" fill class="footer-logo-img" />
          </a>
          <div class="footer-columns-container cluster" style="--cluster-gap: var(--space-m)">
            @if (footerVariant === 'full') {
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              <a class="footer-title" [routerLink]="['/article', 'aposmart']" i18n="@@footer.about.heading">OM OSS</a>
              <a [routerLink]="['/article', 'aposmart']" i18n="@@footer.about.about">Om Aposmart
              </a>
              <a [routerLink]="['/article', 'hur-fungerar-aposmart']" i18n="@@footer.about.how">Hur funkar Aposmart?
              </a>
              <a [routerLink]="['/apotek']" i18n="@@footer.about.pharmacies">Om apoteken</a>
              <a href="https://www.varden.se/info/om-varden/om-oss" rel="nofollow" i18n="@@footer.about.varden">Om Vården.se</a>
              <a href="https://www.varden.se/" rel="nofollow" i18n="@@footer.about.tovarden">
                Till Vården.se
              </a>
			  <a [routerLink]="['/careers']" i18n="@@footer.about.careers">Karriär</a>
              @if (showGatedLegalLinks) {
              <a [routerLink]="['/article', 'foretagsinformation']" i18n="@@footer.about.companyInfo">Företagsinformation</a>
              }
            </div>
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              <span class="footer-title" i18n="@@footer.articles.heading">ARTIKLAR</span>
			  <a [routerLink]="['/article', 'e-barometern-2025-apoteksbranschen-leder-svensk-e-handel']" i18n="@@footer.articles.ebarometer">2025: Apoteken leder svensk e-handel</a>
			  <a
                [routerLink]="['/article', 'augusti-2025-prisrapport-visar-kraftiga-prishojningar-pa-allergilakemedel']" i18n="@@footer.articles.priceReport">Senaste
                prisrapporten</a>
              <a [routerLink]="['/article', 'apotek-pa-natet-online-fordelar']" i18n="@@footer.articles.onlineAdvantages">Fördelar med nätapotek</a>
              <a [routerLink]="['/bast-i-test', 'omega-3']" i18n="@@footer.articles.omega3">Omega-3 guide: Välj rätt</a>
              <a [routerLink]="['/article', 'aposmart-ai']" i18n="@@footer.articles.ai">AposmartAI</a>
              <a [routerLink]="['/article', 'smart-inkopslista-spara-pengar-med-aposmart']" i18n="@@footer.articles.shoppingList">Smart inköpslista</a>
              <a [routerLink]="['/article', 'blodprov-fore-kosttillskott']" i18n="@@footer.articles.supplements">Tar du kosttillskott?</a>
            </div>
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              <span class="footer-title" i18n="@@footer.guides.heading">PRISGUIDER</span>
              <a [routerLink]="['/guide', 'prisjamforelse-mounjaro-wegovy-ozempic-saxenda']" i18n="@@footer.guides.weightLoss1">Prisjämförelse Mounjaro,
                Wegovy</a>
              <a [routerLink]="['/guide', 'allergilakemedel-pollensasong-prisjamforelse']" i18n="@@footer.guides.allergy">Allergiläkemedel
                pollensäsong</a>
              <a [routerLink]="['/guide', 'hogkostnadsskyddet-2026-prisguide-formanen']" i18n="@@footer.guides.costProtection">Högkostnadsskyddet 2026</a>
              <a [routerLink]="['/guide', 'fran-receptfritt-till-receptbelagt-aknebehandling-kostnad']" i18n="@@footer.guides.acne">Aknebehandling
                kostnad</a>
              <a [routerLink]="['/guide', 'prisguide-for-haravfall-minoxidil-finasterid-prp-hartransplantation']"
                title="Komplett prisguide för medicinsk håravfallsbehandling - Minoxidil, Finasterid, PRP och hårtransplantation" i18n-title="@@footer.guides.hairLoss.title" i18n="@@footer.guides.hairLoss">
                Håravfallsbehandling prisguide
              </a>
              <a [routerLink]="['/guide', 'reducerad-moms-kosttillskott-pris-fore-efter']" i18n="@@footer.guides.vat">Reducerad moms
                kosttillskott</a>
              <a [routerLink]="['/guide', 'prisjamforelser-viktnedgang-ayd-yazen-fit-for-livet-vikto-velora']" i18n="@@footer.guides.weightLoss2">Medicinsk
                viktnedgång 2026</a>
            </div>
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              <span class="footer-title" i18n="@@footer.links.heading">SNABBLÄNKAR</span>
			  <a [routerLink]="['/apotek']" i18n="@@footer.links.pharmacies">Apotek & butiker</a>
              <!-- Swedish and unmarked like the rest of the restnoteringar feature: the
                   copy renders only under the SE-only full footer behind this gate, and a
                   new i18n id would stop every other market's build on a missing target. -->
              @if (drugShortagesEnabled) {
              <a [routerLink]="['/restnoteringar']" class="contact-link">
                <mat-icon svgIcon="restnot" />
                <span>Restnoterat</span>
              </a>
              }
			  <!--<a [routerLink]="['/chat']" class="contact-link">
                <mat-icon>smart_toy</mat-icon> AposmartAI
              </a>-->
              <a [routerLink]="['/article', 'cookiepolicy']" rel="nofollow" i18n="@@footer.links.cookies">Cookiepolicy</a>
              <!-- Persistent way back to the banner, so withdrawing consent is as
                   easy as giving it. Same guard as the limited footer below. -->
              @if (consent.selfHosted) {
              <button type="button" class="footer-link-button" (click)="consent.reopen()"
                i18n="@@footer.links.cookieSettings">Cookie-inställningar</button>
              }
              <a [routerLink]="['/article', 'anvandarvillkor']" rel="nofollow" i18n="@@footer.links.terms">Användarvillkor</a>
              @if (showGatedLegalLinks) {
              <a [routerLink]="['/article', 'ansvarsfriskrivning']" rel="nofollow" i18n="@@footer.links.disclaimer">Ansvarsfriskrivning</a>
              }
              <a [routerLink]="['/article', 'rapportera-fel']" rel="nofollow" i18n="@@footer.links.reportBug">Rapportera fel</a>
              <a [routerLink]="['/article', 'apotekens-fraktalternativ']" i18n="@@footer.links.shipping">Fraktalternativ</a>
              <a href="https://www.aposmart.se/public/widget/index.html" class="contact-link"><mat-icon>code</mat-icon><span i18n="@@footer.links.widget"> Widget</span></a>
              <a routerLink="/login" class="contact-link"><mat-icon>query_stats</mat-icon> <span i18n="@@footer.links.brandPortal">Brand Portal</span></a>
            </div>
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              <span class="footer-title" i18n="@@footer.contact.heading">KONTAKT</span>
              <a [routerLink]="['/article', 'kontakta-oss']" class="contact-link"><mat-icon>email</mat-icon> <span i18n="@@footer.contact.contactUs">Kontakta oss</span></a>
              <a href="https://www.facebook.com/aposmart.se" class="contact-link"><mat-icon>facebook</mat-icon> <span i18n="@@footer.contact.facebook">Facebook</span></a>
              <a href="https://www.linkedin.com/company/aposmart-se/" class="contact-link"><mat-icon>people</mat-icon> <span i18n="@@footer.contact.linkedin">LinkedIn</span></a>
              <a href="https://www.instagram.com/aposmart.se/" class="contact-link"><mat-icon>camera_alt</mat-icon> <span i18n="@@footer.contact.instagram">Instagram</span></a>
			  <a href="https://deltapricing.se/" class="contact-link"><mat-icon>business_center</mat-icon> <span i18n="@@footer.contact.deltaPricing">Delta Pricing AB</span></a>
            </div>
            @defer{ @if (!isPortalRoute()) {
            <div class="footer-column newsletter-column stack" style="--stack-gap: var(--space-3xs)">
              <span class="footer-title" i18n="@@footer.newsletter.heading">NYHETSBREV</span>
              <p class="newsletter-description" i18n="@@footer.newsletter.description">Erbjudanden & nyheter direkt i din inbox.</p>
              <iframe class="newsletter-iframe" loading="lazy"
                src="https://cdn.forms-content-1.sg-form.com/9597a2b0-2b11-11ef-b91e-16378875d057"></iframe>
            </div>
            } } @error {}
            } @else {
            @if (footerLegalLinks.length) {
            <!-- Two columns rather than one: the legal list is the only column this
                 footer renders, and eight links stacked in a single run left it far
                 taller than it is wide. The cluster stacks the halves back in
                 reading order when it wraps, so narrow screens are unchanged. -->
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              @for (link of footerLegalLinksFirst; track link.path) {
              <a [routerLink]="link.path" rel="nofollow">{{ link.label }}</a>
              }
            </div>
            <div class="footer-column stack" style="--stack-gap: var(--space-2xs)">
              @for (link of footerLegalLinksSecond; track link.path) {
              <a [routerLink]="link.path" rel="nofollow">{{ link.label }}</a>
              }
              <!-- Persistent way back to the banner, so withdrawing consent is as
                   easy as giving it. Only on markets running our own banner:
                   A hosted CMP would provide its own widget instead. -->
              @if (consent.selfHosted) {
              <button type="button" class="footer-link-button" (click)="consent.reopen()"
                i18n="@@footer.links.cookieSettings">Cookie-inställningar</button>
              }
            </div>
            }
            }
          </div>
          <div class="footer-logo-container cluster" style="--cluster-gap: var(--space-2xs)">
            <div #logoCarousel class="logo-carousel-container">
			  <div class="logo-carousel">
                @for (a of logoStrip(); track $index) {
                <div [attr.aria-hidden]="$index >= apotekLogos().length ? 'true' : null">
                  @if (getImage(a.name)) {
                  <!-- /apotek is SE-only (countryGuard), so outside SE the logos render
                       unlinked rather than pointing at a route that redirects home.
                       The second copy of the strip exists only to make the loop
                       seamless, so it is never linked either: fifteen duplicate
                       footer links on every page is not something to hand a crawler. -->
                  @if (isSEMarket && $index < apotekLogos().length) {
                  <a class="logo-item" [routerLink]="['/apotek']">
                    <img [src]="getImage(a.name)" [alt]="getDisplayName(a.name) + ' logo'" class="logo-image" />
                  </a>
                  } @else {
                  <span class="logo-item">
                    <img [src]="getImage(a.name)" [alt]="getDisplayName(a.name) + ' logo'" class="logo-image" />
                  </span>
                  }
                  }
                </div>
                }
              </div>
            </div>
          </div>
          <!-- Market switcher. Every market renders it, listing the others; the
               row sits outside the footerVariant branch above so the full SE
               footer and the limited EU footer show it identically. Targets are
               our own ccTLDs, so absolute [href] rather than [routerLink], and
               no rel="nofollow". -->
          <div class="market-switcher cluster" style="--cluster-gap: var(--space-s)">
            @for (market of marketLinks; track market.href) {
            <!-- Flag-only, so the market name moves into alt: without it the link
                 has no accessible name at all. -->
            <a class="market-switcher-link" [href]="market.href">
              <img class="market-switcher-flag" [src]="market.flagSrc" [alt]="market.label" width="40" height="30" />
            </a>
            }
          </div>
          <div class="disclaimer-wrapper">
            <small class="disclaimer-text" i18n="@@footer.disclaimer">
              Informationen om apoteksvaror, lagerstatus och priser hämtas från externa källor och
              kan ändras; {{ orgName }} ansvarar ej för fullständig riktighet.
              {{ orgName }} är inte ett apotek och säljer inte läkemedel.
              Vissa länkar är annonslänkar som kan ge ersättning.
              Amazon och Amazon-logotypen är varumärken som tillhör Amazon.com, Inc. eller dess dotterbolag.
              Informationen på sidan ersätter inte medicinsk
              rådgivning – rådgör alltid med legitimerad läkare eller farmaceut vid frågor.
              Receptbelagda läkemedel presenteras endast informativt, inte som marknadsföring. Alla varumärken tillhör
              respektive ägare.
              Alla priser anges i svenska kronor inkl. moms. Fraktkostnader visas separat eller ingår i
              priset beroende på inställning.
            </small>
          </div>
          <!-- "fd. Apotekskollen" is the former Swedish brand name; it means nothing
               on the new markets, so they get the plain copyright line. -->
          @if (isSEMarket) {
          <span class="copyright-text" i18n="@@footer.copyright">
            Copyright &copy; 2026 {{ orgName }} (fd. Apotekskollen)</span>
          } @else {
          <span class="copyright-text" i18n="@@footer.copyrightPlain">
            Copyright &copy; 2026 {{ orgName }}</span>
          }
		  </div>
        </footer>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<!-- Mounted here rather than in AppComponent so it never appears on the brand
     portal, which is a Swedish-only product on its own layout. bannerOpen() is
     already false on hosted-CMP markets and before hydration. -->
@if (consent.bannerOpen()) {
<app-consent-banner />
}
